// Permission enums and the check-input union now live in `@moment/app-config-ui`
// so packages can consume them directly. Re-exported here so existing
// `@/types/schema/permissions` import sites keep working unchanged.
export {
  CheckOnlyPermission,
  Permission,
  type PermissionCheck,
} from '@moment/app-config-ui/permissions'
